import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Button } from '../../../../Components/Atoms';
import { getConfig } from '../../../../utils/config';
import useData from './data';
import ReactGA from 'react-ga4';
import { getKYCStatus, LinkParagraph, renderDate } from '../../../../helpers';
import { cmsClient, winnreAuth } from '../../../../utils/axios';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../../../store/auth-slice';
import MdPlayCircleOutline from '@meronex/icons/md/MdPlayCircleOutline';
import EiPlay from '@meronex/icons/ei/EiPlay';
import ReactPlayer from 'react-player';
import Modal from '../../../../Components/Organisms/Modal';
import GrClose from '@meronex/icons/gr/GrClose';
import { toast } from 'react-toastify';
import SkeletonDeal from '../../../../Components/Molecules/Skeleton/SkeletonDeal';
import PhoneNumber from '../PhoneNumber';
import DealGalleryItem from '../DealGalleryItem';
import RedeemAnimation from '../RedeemButtonAnimation';
import {
    EmailShareButton,
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton
} from 'react-share';
import SiWhatsapp from '@meronex/icons/si/SiWhatsapp';
import FaFacebookF from '@meronex/icons/fa/FaFacebookF';
import FiCopy from '@meronex/icons/fi/FiCopy.js';
import MdcEmailOutline from '@meronex/icons/mdc/MdcEmailOutline';
import EnShareAlternative from '@meronex/icons/en/EnShareAlternative';
import EiCloseO from '@meronex/icons/ei/EiCloseO';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import DealEnquiry from '../../../DealEnquiry';
import BsArrowLeft from '@meronex/icons/bs/BsArrowLeft';
import {
    copyCodeHandler,
    toIndianRs,
    toNumberFormat
} from '../../../../helpers';
import useKYC from '../../../../Hooks/use-KYC';
import KYCModal from '../../../../Components/Organisms/KYCModal';
import useBookingSummary from '../../../../Hooks/use-bookingSummary';
import ZeroDeals from '../ZeroDeals';
import { StepButton } from '@mui/material';
import RewardClaimDescription from '../RewardClaimDescription';
import Description from '../Description';
import MiniSurvey from './MiniSurvey';
import IosArrowBack from '@meronex/icons/ios/IosArrowBack';

import { dealAction } from '../../../../store/deal-slice';
import store from '../../../../store';
import SideModal from '../../../../Components/Organisms/SideModal';
import Fireworks from '../../../../Components/Atoms/FireWorks';
import DealValidity from './Components/DealValidity';
import TnC from './Components/TnC';
import MoreOffers from './Components/MoreOffers';
import { AlertSvg, BuyNowSvg, testSvg, TickSvg } from './Components/SVG';
import ZeroState from '../../../../Components/Organisms/ZeroState';
import RewardsPopupModal from '../../../../Components/Organisms/RewardsPopupModal';

const settings = {
    // dots: true,
    infinite: true,
    // speed: 10000,
    slidesToShow: 5,
    // slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    width: '70px',
    draggable: true,
    slidesToScroll: 3
    // adaptiveHeight: true,
    // easing: 'linear'
};

const isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);

function DealDetails({ isRewards }) {
    const params = useParams();
    const history = useHistory();
    const currentUrl = window.location.pathname;
    const [showTerms, setShowTerms] = useState(false);
    const [showUnregisteredModal, setShowUnregisteredModal] = useState(false);
    const [copiedText, setCopiedText] = useState(false);
    const [copiedLink, setCopiedLink] = useState(false);
    const [playVideo, setPlayVideo] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showShare, setShowShare] = useState(true);
    const [voucherCode, setVoucherCode] = useState(null);
    const [modalMessage, setModalMessage] = useState(null);
    const [rememptionLoading, setRedemptionLoading] = useState(false);
    const [termsCheckbox, setTermsCheckbox] = useState(true);
    const [previewItem, setPreviewItem] = useState(null);
    const [disableCart, setDisableCart] = useState(false);
    const [showTnCWarning, setShowTnCWarning] = useState(false);
    const [showMultipleRedemption, setShowMultipleRedemption] = useState(false);
    const {
        loadingDeal,
        deal,
        similarOffers,
        topOffers,
        sameBrandOffers,
        bundleDeals,
        bundleDealDetails,
        faultyDeal,
        otherBundleDeals
    } = useData(params.dealId, isRewards);

    console.log('Deal INside detail', deal);
    console.log('otherbundleDeals', otherBundleDeals);

    const {
        step,
        setStep,
        setError,
        showError,
        checkKycVerificationStatus,
        closeKYCModal,
        setOpenKYCModal,
        openKYCModal,
        loading,
        checkBankVerificationStatus,
        isUpdateWorkflow,
        isKycCompleted,
        initiateWorkflow,
        claimInProgress,
        rewardTypeSelected,
        cashOutFlow,
        setClaimInProgress,
        bankstatus,
        isKycFailed,
        isBankVerificationFailed,
        isKycProcessing
    } = useKYC();

    const { userAccountSummary, getUserAccountSummary } = useBookingSummary();

    const location = useLocation();
    const dispatch = useDispatch();
    const queryParams = new URLSearchParams(location.search);
    const accessToken = queryParams.get('token');
    const userToken = queryParams.get('userToken');
    const clientToken = queryParams.get('clientToken');
    const dealCategory = queryParams.get('category');
    const tagId = queryParams.get('tagid');
    const channel = queryParams.get('utm_medium');
    const userHash = queryParams.get('user');
    const isRedeemUser = queryParams.get('user') ? true : false;
    const autoRedeem = queryParams.get('autoRedeem');
    const config = getConfig();
    const [showShareModal, setShowShareModal] = useState(false);
    const [copiedUrl, setCopiedUrl] = useState(false);
    const [captureUserMobile, setCaptureUserMobile] = useState(false);
    const [redemptionId, setRedemptionId] = useState(null);
    const [prefilledData, setPrefilledData] = useState([]);
    const [link, setLink] = useState('');
    const [shareLink, setShareLink] = useState(''); // used to generate short share link
    const [showSurvey, setShowSurvey] = useState(false);
    const [itemAdded, setItemAdded] = useState(false);
    const isKycModalEnabled = useSelector(
        (state) => state.deals.isKycModalEnabled
    );
    const redeemNowButtonConfig =
        config?.deals.dealLayout.redeemNowButtonConfig;

    const showRewardsModal = useSelector(
        (state) => state.deals.showRewardsModal
    );

    // const token = useSelector((state) => state.auth.token);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const userMobile = useSelector(
        (state) => state.auth.userDetails.mobileNumber
    );

    const openLoginModal = () => {
        dispatch(authActions.openLoginModal());
    };
    const openLoginModalForDealRedeem = () => {
        dispatch(authActions.openLoginModalForDealRedeem());
    };

    console.log('showTncWarning', showTnCWarning);

    useEffect(() => {
        const visitCount = sessionStorage.getItem('dealDetailsVisitCount');
        let visitNum = visitCount ? parseInt(visitCount, 10) : 0;
        visitNum += 1;
        sessionStorage.setItem('dealDetailsVisitCount', visitNum);
        const surveyShown = sessionStorage.getItem('surveyShown');

        if (!surveyShown && visitNum >= 4) {
            setShowSurvey(true);
            console.log('visitCount', visitNum);
        }
    }, []);

    const handleCloseSurvey = () => {
        setShowSurvey(false);
        sessionStorage.setItem('surveyShown', 'true');
    };

    // checkout handler

    const checkKYCStatus = () => {
        winnreAuth({
            method: 'GET',
            url: `/winnre/user/user/kyc-status`
        }).then((message) => {
            if (message.message == 'COMPLETED') {
                dispatch(dealAction.setShowRewardsModal(true)); // Open modal on Buy Now click
                // history.push(`/checkout`);
            }
            if (
                message.message == 'NOT_INITIATED' ||
                message.message == 'INITIATED' ||
                message.message === 'null' ||
                message.message === 'FAILED' ||
                message.message == 'PROCESSING'
            ) {
                checkKycVerificationStatus(false, true, false);
                setOpenKYCModal(true);
            }
        });
    };
    // To open kyc modal from cart checkout
    useEffect(() => {
        if (isKycModalEnabled) {
            setOpenKYCModal(true);
        }
    }, [isKycModalEnabled]);

    const handleCheckOut = (isBuyNow) => {
        if (isBuyNow) {
            window?.webengage?.track('BuyNowClicked', {
                category: `${deal?.category?.name}`,
                ProductName: `${deal?.title}`,
                Price: `${deal?.productMrp}`,
                PointsRequired: `${deal?.points}`
            });
            OnCartClick(false);
        }
        window?.webengage?.track('RewardRedemptionAttempt');
        checkKYCStatus();

        // checkKycVerificationStatus(false, true);
        // setOpenKYCModal(true);
        // setError(null);
        //UNCOMMENT
        // history.push(`/checkout/${deal?.id}`);
    };

    // Hide the background scroll when modal is enabled.
    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = ''; // Reset to default when modal is closed
        }

        // Cleanup function to ensure overflow is reset when the component unmounts
        return () => {
            document.body.style.overflow = '';
        };
    }, [showModal]);

    const clientWebview = useSelector((state) => state.webView.clientWebview);
    const userStatus = useSelector((state) => state.auth.userDetails?.status);
    const internalWebview = useSelector(
        (state) => state.webView.internalWebview
    );
    const clickThroughMobile = clientWebview || internalWebview;
    let isBundleDeal = deal?.category?.id == '8';
    let isFinanceDeal = deal?.category?.id == '3';
    console.log('UserStatus', userStatus);

    const isOfflineTag = deal?.tags?.some((tag) => tag.name === 'Offline');
    const hasBothTags =
        deal?.tags?.some((tag) => tag.name === 'Offline') &&
        deal?.tags?.some((tag) => tag.name === 'Multiple');
    const isHouseWarmingTag = deal?.tags?.some(
        (tag) => tag.name === 'House Warming'
    );


    // console.log("hasBothTags" , hasBothTags);
    useEffect(() => {
        setTermsCheckbox(true);
    }, [params?.dealId]);

    useEffect(() => {
        let enableShare = userHash ? false : true;
        if (
            !isAuthenticated &&
            !userToken &&
            !accessToken &&
            !clientToken &&
            enableShare &&
            !deal?.shareable
        ) {
            openLoginModal();
        }
        setShowShare(enableShare);
    }, []);

    useEffect(() => {
        if (deal) {
            window?.webengage?.track('DealViewed', {
                OfferName: `${deal?.title}`,
                Brand: `${deal?.vendor?.name}`,
                OfferType: `${deal?.category?.name}`,
                OfferImage: `${deal?.displayImage?.url}`,
                CashbackPercentage: `${deal?.eligibleCashback}`,
                CouponCode: `${deal?.dealRedemptionCode?.dealCode}`,
                Category: `${deal?.category?.name}`,
                Link: `${deal?.url}`,
                EndDate: `${deal?.endDate}`,
                Tags: `${deal?.tags?.map((tag) => tag?.name)}`,
                DealId: `${deal?.id}`,
                SectionName: `${isRewards === true ? 'Rewards' : 'Deals'}`,
                DealPoint: `${deal?.points}`,
                Mrp: `${deal?.productMrp}`,
                RedemptionType: `${deal?.redemptionType}`,
                Points: deal?.points
            });
        }

        if (deal?.videoUrl) {
            setPreviewItem(deal?.videoUrl);
        } else {
            setPreviewItem(deal?.displayImage?.url);
        }
    }, [deal]);

    useEffect(() => {
        if (deal && autoRedeem) {
            if (isBundleDeal) {
                if (bundleDeals?.length > 0 && bundleDealDetails?.length > 0) {
                    queryParams.delete('autoRedeem');
                    history.replace({
                        search: queryParams.toString()
                    });
                    redeemNowClickedHandler(
                        deal.url,
                        deal.id,
                        deal?.redemptionType
                    );
                }
            } else {
                queryParams.delete('autoRedeem');
                history.replace({
                    search: queryParams.toString()
                });
                redeemNowClickedHandler(
                    deal.url,
                    deal.id,
                    deal?.redemptionType
                );
            }
        }
    }, [deal, bundleDealDetails, bundleDeals]);

    const handleCopyCode = async () => {
        const code =
            deal?.redemptionType == 'VOUCHER'
                ? voucherCode
                : deal?.dealRedemptionCode?.dealCode;
        await copyCodeHandler(code, setCopiedText);
    };

    const handleCopyLink = async () => {
        await copyCodeHandler(deal?.url, setCopiedLink);
    };

    const imgArr = bundleDeals?.map((deal) => {
        return {
            imgUrl: deal?.vendorLogoUrl || '',
            dealName: deal?.title,
            dealImage: deal?.thumbnailImageUrl
                ? deal?.thumbnailImageUrl
                : deal?.displayImageUrl,
            dealId: deal?.id
        };
    });
    const getPrefilledData = () => {
        winnreAuth({
            method: 'GET',
            url: '/winnre/user/property/consultation-deal-additional-details'
        }).then((res) => {
            console.log('prefilledData', res);
            setPrefilledData(res);
        });
    };

    const redeemNowClickedHandler = (url, id, redemptionType, mobile) => {
        if (isRedeemUser && !isAuthenticated) {
            // enable only if the user access the shared deal
            history.push(
                `${location.pathname}?postLoginUrl=/deals/${id}?autoRedeem=true`
            );
            openLoginModalForDealRedeem();
        } else if (
            !isAuthenticated &&
            !userToken &&
            !accessToken &&
            !clientToken
        ) {
            openLoginModal();
        } else {
            if (!userMobile && !mobile) {
                setCaptureUserMobile(true);
                setShowModal(true);
                return;
            }
            setRedemptionLoading(true);
            setModalMessage(null);
            if (
                cmsClient.defaults.baseURL === 'https://prod.loyalie.in' ||
                cmsClient.defaults.baseURL === 'https://uat.loyalie.in'
            ) {
                window.fbq('trackCustom', 'RedeemNowButtonClicked');
            }
            ReactGA.event({
                category: 'OFFER',
                action: 'REDEEM NOW CLICKED',
                label: 'REDEEM OFFER BUTTON'
            });
            let apiCall;

            // To add source user if the deal is shared.

            let sourceUserId = userHash ? `&sourceUserId=${userHash}` : '';

            if (isBundleDeal) {
                apiCall = Promise.all(
                    bundleDeals?.map((bundleDeal) =>
                        winnreAuth({
                            method: 'POST',
                            url: `winnre/user/deals/redeem-v2?dealId=${
                                bundleDeal?.id
                            }&sourcePlatform=${
                                clickThroughMobile ? 'MOBILE' : 'WEBSITE'
                            }${
                                channel ? `&channel=${channel}` : ''
                            }${sourceUserId}`
                        })
                    )
                );
            } else {
                apiCall = winnreAuth({
                    method: 'POST',
                    url: `winnre/user/deals/redeem-v2?dealId=${id}&sourcePlatform=${
                        clickThroughMobile ? 'MOBILE' : 'WEBSITE'
                    }${channel ? `&channel=${channel}` : ''}${sourceUserId}`
                });
            }
            apiCall
                .then((res) => {
                    console.log('redeem', res);
                    setRedemptionId(res?.dealRedemptionId);
                    if (isBundleDeal) {
                        let index = 0;
                        const offers = bundleDealDetails || [];
                        for (const bundleDeal of bundleDeals) {
                            // console.log(bundleDeal.title, bundleDeal.redemptionType, bundleDeal.eligibleCashback, bundleDeal.dealRedemptionCode, bundleDeal.endDate, bundleDeal.id, bundleDeal.categoryName, bundleDeal.vendorName)
                            window?.webengage?.track('DealClicked', {
                                OfferName: `${bundleDeal?.title}`,
                                RedemptionType: `${bundleDeal?.redemptionType}`,
                                CashbackPercentage: `${bundleDeal?.eligibleCashback}`,
                                CouponCode: `${bundleDeal?.dealRedemptionCode}`,
                                Category: `${bundleDeal?.categoryName}`,
                                Vendor: `${bundleDeal?.vendorName}`,
                                Link: `${bundleDeal?.url}`,
                                EndDate: `${bundleDeal?.endDate}`,
                                SectionName: `${
                                    isRewards === true ? 'Rewards' : 'Deals'
                                }`,
                                DealPoint: `${deal?.points}`,
                                Mrp: `${deal?.productMrp}`,
                                RedemptionType: `${deal?.redemptionType}`,
                                Tags: `${bundleDeal?.tags?.map(
                                    (tag) => tag?.name
                                )}`,
                                DealId: `${bundleDeal?.id}`,
                                VoucherCode:
                                    bundleDeal.dealType === 'OFFLINE'
                                        ? ''
                                        : bundleDeal?.redemptionType ===
                                              'VOUCHER' &&
                                          res[index]?.status == 'SUCCESS'
                                        ? res[index]?.dealCode
                                        : res[index]?.status == 'FAILED' &&
                                          res[index]?.message.includes(
                                              'Repeat:'
                                          )
                                        ? res[index]?.message.split(
                                              'Repeat:'
                                          )[1]
                                        : '',
                                Channel: channel ? channel : 'Direct',
                                ...(bundleDeal.redemptionType === 'VOUCHER' &&
                                    bundleDeal.dealType === 'OFFLINE' && {
                                        QRCode:
                                            res[index]?.status == 'SUCCESS'
                                                ? res[index]?.dealQrCodeLink
                                                : res[index]?.status == 'FAILED'
                                                ? res[index]?.message.split(
                                                      'Repeat:'
                                                  )[1]
                                                : ''
                                    })
                            });
                            const offersIndex = offers.findIndex(
                                (o) => o.id === bundleDeal?.id
                            );
                            offers[offersIndex] = {
                                ...offers[offersIndex],
                                ...bundleDeal,
                                VoucherCode:
                                    bundleDeal.dealType === 'OFFLINE'
                                        ? ''
                                        : bundleDeal?.redemptionType ===
                                              'VOUCHER' &&
                                          res[index]?.status == 'SUCCESS'
                                        ? res[index]?.dealCode
                                        : res[index]?.status == 'FAILED' &&
                                          res[index]?.message.includes(
                                              'Repeat:'
                                          )
                                        ? res[index]?.message.split(
                                              'Repeat:'
                                          )[1]
                                        : '',
                                ...(bundleDeal.redemptionType === 'VOUCHER' &&
                                    bundleDeal.dealType === 'OFFLINE' && {
                                        QRCode:
                                            res[index]?.status == 'SUCCESS'
                                                ? res[index]?.dealQrCodeLink
                                                : res[index]?.status == 'FAILED'
                                                ? res[index]?.message.split(
                                                      'Repeat:'
                                                  )[1]
                                                : ''
                                    })
                            };
                            index++;
                        }
                        setRedemptionLoading(false);
                        history.push({
                            pathname: '/bundleDetails',
                            state: {
                                offers: offers,
                                filteredOffers: otherBundleDeals
                            }
                        });
                        window?.webengage?.track('PdfViewed');
                    } else {
                        window?.webengage?.track('DealClicked', {
                            OfferName: `${deal?.title}`,
                            RedemptionType: `${deal?.redemptionType}`,
                            CashbackPercentage: `${deal?.eligibleCashback}`,
                            CouponCode: `${deal?.dealRedemptionCode?.dealCode}`,
                            Category: `${deal?.category?.name}`,
                            Vendor: `${deal?.vendor?.name}`,
                            Link: `${deal?.url}`,
                            EndDate: `${deal?.endDate}`,
                            Tags: `${deal?.tags?.map((tag) => tag?.name)}`,
                            DealId: `${deal?.id}`,
                            SectionName: `${
                                isRewards === true ? 'Rewards' : 'Deals'
                            }`,
                            DealPoint: `${deal?.points}`,
                            Mrp: `${deal?.productMrp}`,
                            RedemptionType: `${deal?.redemptionType}`,
                            VoucherCode:
                                deal?.dealType === 'OFFLINE'
                                    ? ''
                                    : deal?.redemptionType === 'VOUCHER'
                                    ? res?.status == 'SUCCESS'
                                        ? res?.dealCode
                                        : res?.status == 'FAILED' &&
                                          res?.message.includes('Repeat:')
                                        ? res?.message.split('Repeat:')[1]
                                        : ''
                                    : '',
                            ...(redemptionType === 'VOUCHER' &&
                                deal.dealType === 'OFFLINE' && {
                                    QRCode:
                                        res?.status == 'SUCCESS'
                                            ? res?.dealQrCodeLink
                                            : res?.status == 'FAILED'
                                            ? res?.message.includes('Repeat:')
                                                ? res?.message.split(
                                                      'Repeat:'
                                                  )[1]
                                                : ''
                                            : ''
                                }),
                            Status: res?.status,
                            Channel: channel ? channel : 'Direct'
                        });
                        setRedemptionLoading(false);
                        if (
                            userStatus !== 'REGISTERED' &&
                            res?.status === 'FAILED' &&
                            res?.message ===
                                'Deal redemption is not allowed for this user'
                        ) {
                            setShowUnregisteredModal(true);
                            return;
                        }
                        if (hasBothTags) {
                            setShowMultipleRedemption(true);
                            return;
                        }
                        if (
                            res?.status === 'SUCCESS' &&
                            isFinanceDeal &&
                            res?.dealRedemptionId
                        ) {
                            console.log('navigate to home loan');
                            // Navigate to '/home-loan' and pass dealRedemptionId as state
                            history.push('/home-loans', {
                                dealRedemptionId: res.dealRedemptionId
                            });
                        }
                        if (redemptionType === 'CODE') {
                            setShowModal(true);
                            if (res?.status == 'SUCCESS') {
                                setVoucherCode(
                                    deal?.dealRedemptionCode?.dealCode
                                );
                            }
                            if (res?.status == 'FAILED') {
                                if (res?.message.includes('Repeat:')) {
                                    setModalMessage(
                                        'The coupon code has already been used for this deal.'
                                    );
                                } else {
                                    setModalMessage(res?.message);
                                }
                                setVoucherCode(null);
                            }
                            // handleCopyCode();
                            // window.open(url);
                            return;
                        }
                        if (redemptionType === 'LINK') {
                            window.open(url);
                            return;
                        }
                        if (redemptionType === 'CONSULTATION') {
                            if (
                                res?.status == 'SUCCESS' &&
                                isHouseWarmingTag &&
                                res?.dealRedemptionId
                            ) {
                                setShowModal(true);
                                getPrefilledData();
                            }
                            if (res.status === 'FAILED') {
                                setModalMessage(res.message);
                            }
                            return;
                        }
                        if (redemptionType === 'VOUCHER') {
                            setShowModal(true);
                            if (res?.status == 'SUCCESS') {
                                if (deal?.dealType !== 'OFFLINE') {
                                    setVoucherCode(res?.dealCode);
                                    setModalMessage(null);
                                } else {
                                    setVoucherCode(res?.dealQRCodeLink);
                                    setModalMessage(null);
                                }
                            }
                            if (res?.status == 'FAILED') {
                                let code = res?.message.split('Repeat:');
                                if (code.length > 1) {
                                    if (deal?.dealType == 'ONLINE') {
                                        setVoucherCode(code[1]);
                                        if (isOfflineTag) {
                                            setModalMessage(
                                                'Show the voucher code at the restaurant/store to claim your offer.'
                                            );
                                        } else {
                                            setModalMessage(
                                                `You have already viewed your voucher! Go to ${deal?.vendor?.name} website to redeem the voucher directly online`
                                            );
                                        }
                                        // setModalMessage(
                                        //     `You have already viewed your voucher! Go to ${deal?.vendor?.name} website to redeem the voucher directly online`
                                        // );
                                    } else if (deal?.dealType == 'OFFLINE') {
                                        setVoucherCode(code[1]);
                                        setModalMessage(
                                            'You have already redeemed this deal. We have resent the details to you!'
                                        );
                                    }
                                } else {
                                    setModalMessage(res?.message);
                                    setVoucherCode(null);
                                }
                            }
                        }
                    }
                })
                .catch(() => {
                    setRedemptionLoading(false);
                    if (redemptionType === 'CONSULTATION') {
                        toast.error('Something Went Wrong');
                    }
                });
        }
    };
    const handleTnC = () => {
        setShowTerms(true);
        window?.webengage?.track('TnCViewed', {
            dealId: `${deal.id}`,
            dealTitle: `${deal.title}`,
            vendorName: `${deal.vendor.name}`,
            SectionName: `${isRewards === true ? 'Rewards' : 'Deals'}`,
            DealPoint: `${deal?.points}`,
            Mrp: `${deal?.productMrp}`,
            RedemptionType: `${deal?.redemptionType}`
        });
    };

    const handleOnChange = () => {
        setTermsCheckbox((prev) => !prev);
    };

    //To get logged in user details for share link.
    const userId = useSelector((state) => state.auth.userHash);
    const user = useSelector((state) => state.auth.userId);
    const userRole = useSelector((state) => state.auth.userRole);
    const totalRewardspoint = useSelector((state) => state.auth.rewardPoints);
    const isCartModalOpen = useSelector(
        (state) => state.deals.isCartModalVisible
    );
    //To generate shared deal link.
    const copyDealHandler = async () => {
        if ('clipboard' in navigator) {
            if (!isAuthenticated || userRole !== 'CUSTOMER') {
                await navigator.clipboard.writeText(window.location.href);
            } else if (userRole === 'CUSTOMER') {
                await navigator.clipboard.writeText(link);
            }
        }
        setCopiedUrl(true);
    };

    //To copied deal url enable & disable.
    useEffect(() => {
        const timer = setTimeout(() => {
            setCopiedUrl(false);
        }, 1500);

        return () => {
            clearTimeout(timer);
        };
    }, [copiedUrl]);

    //On click share deal.
    const handleShareClick = (e) => {
        e.preventDefault();
        let links = encodeURIComponent(
            `${window.location.href.split('?')[0]}?dealId=${
                deal?.id
            }&userId=${userId}&user=${user}`
        );
        //To get shortLink
        winnreAuth.post('/winnre/user/short-link?URL=' + links).then((res) => {
            setShareLink(res.shortURL);
            setLink(res.shortURL);
            if (internalWebview) {
                // Message passing for Mobile view
                var valueToSend = {
                    message: 'SHARE_LINK',
                    data: {
                        message: deal.shareMessage
                            ? deal.shareMessage
                            : "Hello! Hope you're doing well. I wanted to share this exciting deal I found recently. Click to learn more!",
                        value: res.shortURL
                    }
                };
                // IOS message handler
                window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                    valueToSend
                );
                var stringifiedValueToSend = JSON.stringify(valueToSend);
                // Android message handler
                window?.JSBridge?.showMessageInNative(stringifiedValueToSend);
            }
            // Show Modal for web view
            else {
                setShowShareModal(true);
            }
        });
    };

    const productSpecifications = isRewards
        ? deal?.productSpecs
        : deal?.description;

    // On cart click

    const handleClick = () => {
        if (!itemAdded) {
            setItemAdded(true);
            // <Fireworks/>
            setTimeout(() => {
                setItemAdded(false);
            }, 4000); // Reset after 4 seconds
        }
    };

    const OnCartClick = (isAddToGiftBasket) => {
        window?.webengage?.track('AddToCartClicked', {
            category: `${deal?.category?.name}`,
            ProductName: `${deal?.title}`,
            Price: `${deal?.productMrp}`,
            PointsRequired: `${deal?.points}`
        });
        const oldCartData = localStorage.getItem('cartData');
        let currentMrp = 0;
        let totalCartCount = 0;
        let totalPoints = 0;
        let cartData = {
            cartValues: [],
            totalMrp: currentMrp,
            totalPoints: totalPoints,
            totalProduct: totalCartCount
        };
        if (oldCartData) {
            cartData = JSON.parse(oldCartData);
            console.log(
                'currentPoints',
                deal?.points,
                'cartTotalPoints',
                cartData?.totalPoints,
                'rewardsTotal',
                totalRewardspoint
            );
            if (
                totalRewardspoint > 0 &&
                deal?.points + cartData?.totalPoints > totalRewardspoint
            ) {
                setDisableCart(true);
                toast(
                    "You don't have enough reward points to redeem this item."
                );
                return;
            }
        }

        // Add the new product to cartValues
        cartData.cartValues.push({
            id: deal?.id,
            title: deal?.title,
            endDate: deal?.endDate,
            displayImageUrl: deal?.displayImage?.url,
            vendorLogoUrl: deal?.vendorLogoUrl,
            productMrp: deal?.productMrp,
            thumbnailImageUrl: deal?.thumbnailImage?.url,
            points: deal?.points,
            productShippingFee: deal?.productShippingFee,
            productConvenienceFee: deal?.productConvenienceFee,
            tags: deal?.tags
        });

        // Update totalMrp and totalProduct
        cartData.totalMrp += deal?.productMrp;
        cartData.totalPoints += deal?.points;
        cartData.totalShippingFee += deal?.productShippingFee;
        cartData.totalConvenienceFee += deal?.productConvenienceFee;
        cartData.totalProduct += 1;

        // Save updated cart data to localStorage
        localStorage.setItem('cartData', JSON.stringify(cartData));
        // Dispatch a custom event to notify other components
        dispatch(dealAction.setCartModalVisible(true));
        window.dispatchEvent(new Event('cartUpdated'));
        const state = store.getState(); // Access the current store state
        const isRefresh = !state.deals.isRefreshRewards;
        dispatch(dealAction.setIsRewardRefreshing(isRefresh));
        if (isAddToGiftBasket) {
            handleClick();
        }
        // handleClick();
    };

    useEffect(() => {
        window.addEventListener('cartUpdated', () => {
            const oldCartData = localStorage.getItem('cartData');
            console.log('cart working', authActions.rewardPoints);
            if (oldCartData) {
                let cartData = JSON.parse(oldCartData);
                if (deal?.points + cartData?.totalPoints > totalRewardspoint) {
                    setDisableCart(true);
                } else {
                    setDisableCart(false);
                }
            }
        });
    }, []);
    const isCartModalVisible = useSelector(
        (state) => state.deals.isCartModalVisible
    );
    console.log('cartModalVisible', isCartModalVisible);

    const handleBackClick = () => {
        // If history.goBack is available and there is valid history, use it
        if (history.length > 2) {
            history.goBack(); // Only use goBack if there's valid history in the stack
        } else {
            if (currentUrl.includes('deals')) {
                history.push('/deals');
            } else if (currentUrl.includes('rewardStore')) {
                history.push('/rewardStore');
            } else {
                history.push('/');
            }
        }
    };

    const isVoucherDeal = deal?.redemptionType === 'VOUCHER';
    const isCodeDeal = deal?.redemptionType === 'CODE';
    const isOnlineDeal = deal?.dealType == 'ONLINE';
    const isOfflineDeal = deal?.dealType == 'OFFLINE';

    const isExternalDeal = deal?.category?.name == 'External';

    return (
        <div
            className={`${internalWebview ? 'mb-16' : ''} ${
                config?.darkMode ? 'bg-black' : 'bg-white'
            }`}
            onClick={() => {
                console.log('Click working');
                dispatch(dealAction.setCartModalVisible(false));
            }}
            style={{
                backgroundImage: `linear-gradient(90deg, rgba(${
                    config?.sectionBackground?.color
                }, ${config?.sectionBackground?.opacity}), rgba(${
                    config?.sectionBackground?.color
                }, ${config?.sectionBackground?.opacity})), url('${
                    config?.sectionBackground?.image
                        ? config?.sectionBackground?.image
                        : ''
                }')`,
                backgroundSize: `${
                    config?.sectionBackground?.size
                        ? config?.sectionBackground?.size
                        : '30% auto'
                }`
            }}
        >
            <section
                className={
                    config?.deals.dealsSection.overlayClass ? 'relative' : ''
                }
            >
                {config?.deals.dealsSection.overlayClass ? (
                    <div
                        className={
                            `${config?.deals.dealsSection.overlayClass}` +
                            ' absolute top-0 bottom-0 left-0 right-0 z-0'
                        }
                    ></div>
                ) : null}

                <div
                    className={`
                    ${config?.bannerNegativeTopMarginClass} w-full h-auto  `}
                >
                    {config?.header && (
                        <div className={config?.header.headerClass}></div>
                    )}
                    {loadingDeal && (
                        <div className="h-auto mx-auto ">
                            <div className="lg:mx-4 ">
                                {[...Array(1).keys()].map((n) => (
                                    <SkeletonDeal key={n} shape="square" />
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                {!isAuthenticated &&
                    !deal.shareable &&
                    !accessToken &&
                    !clientToken && (
                        <div className="py-12 flex justify-center items-center h-[80vh]">
                            <Button
                                {...redeemNowButtonConfig}
                                content="Login to view Offer Details"
                                onClick="FUNC"
                                onClickFunc={openLoginModal}
                                className={redeemNowButtonConfig.className}
                            />
                        </div>
                    )}
                {!loadingDeal && (
                    <div className="w-full lg:w-[95%] xl:w-[93%] mx-auto lg:py-8">
                        {/* Deal details */}
                        {faultyDeal && <ZeroState type="deals" />}

                        <div
                            onClick={handleBackClick}
                            className="flex items-center text-primary cursor-pointer mb-4 "
                        >
                            <IosArrowBack className="inline text-xl" />
                            <p className="inline text-base ">
                                Back to listing page
                            </p>
                        </div>
                        {!faultyDeal &&
                            (isAuthenticated ||
                                (!isAuthenticated && deal?.shareable)) && (
                                <div className="flex flex-col lg:flex-row lg:border-b-2 border-gray-200 items-start lg:pb-7 ">
                                    {(deal?.displayImage?.url &&
                                        deal?.videoUrl) ||
                                    deal?.additionalBannerImages?.length > 0 ? (
                                        <div className="hidden lg:flex flex-col pr-4 max-h-[250px] md:max-h-[480px] lg:max-h-[335px] xl:max-h-[410px] 2xl:max-h-[406px] overflow-hidden">
                                            {deal?.videoUrl && (
                                                <div className="flex relative w-full  justify-center">
                                                    <DealGalleryItem
                                                        imageUrl={
                                                            deal?.displayImage
                                                                ?.url
                                                        }
                                                        videoUrl={
                                                            deal?.videoUrl
                                                        }
                                                        previewItem={
                                                            previewItem
                                                        }
                                                        setPreviewItem={
                                                            setPreviewItem
                                                        }
                                                    />
                                                    <MdPlayCircleOutline className=" absolute self-center text-white text-4xl " />
                                                </div>
                                            )}

                                            {deal?.displayImage?.url && (
                                                <DealGalleryItem
                                                    imageUrl={
                                                        deal?.displayImage?.url
                                                    }
                                                    previewItem={previewItem}
                                                    setPreviewItem={
                                                        setPreviewItem
                                                    }
                                                />
                                            )}
                                            <div
                                                id="DealsDetail"
                                                className="max-w-[70px] max-h-[250px] md:max-h-[480px] lg:max-h-[335px] xl:max-h-[410px] 2xl:max-h-[406px] overflow-y-scroll overflow-y-hidden overflow-x-hidden"
                                            >
                                                {deal?.additionalBannerImages
                                                    ?.length > 0 &&
                                                    deal?.additionalBannerImages?.map(
                                                        (d) => (
                                                            <DealGalleryItem
                                                                imageUrl={
                                                                    d?.url
                                                                }
                                                                previewItem={
                                                                    previewItem
                                                                }
                                                                setPreviewItem={
                                                                    setPreviewItem
                                                                }
                                                            />
                                                        )
                                                    )}
                                            </div>
                                        </div>
                                    ) : null}

                                    {previewItem &&
                                    previewItem === deal.videoUrl ? (
                                        <div
                                            className={`relative h-[250px] md:h-[480px] lg:h-[335px] xl:h-[410px] 2xl:h-[406px] w-full ${
                                                // deal?.redemptionType === 'CONSULTATION'
                                                //     ? 'lg:w-[60%]' :
                                                'lg:w-[50%]'
                                            }`}
                                        >
                                            <ReactPlayer
                                                url={previewItem}
                                                className="react-player absolute self-center !h-[90%]"
                                                playIcon={
                                                    <div className="flex relative w-full mt-10 justify-center ">
                                                        <img
                                                            className="object-contain  w-full brightness-75"
                                                            src={
                                                                deal
                                                                    ?.displayImage
                                                                    ?.url
                                                            }
                                                        />
                                                        <EiPlay className=" absolute self-center text-white text-9xl " />
                                                    </div>
                                                }
                                                playing={playVideo}
                                                light={true}
                                                onClickPreview={() => {
                                                    setPlayVideo(true);
                                                }}
                                                width="100%"
                                                height="100%"
                                                controls={true}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            className={`relative w-full lg:w-[45%] lg:sticky  lg:top-0 h-full`}
                                        >
                                            <img
                                                src={previewItem}
                                                className={`lg:sticky lg:top-0 w-full h-full object-contain  object-top`}
                                            />
                                            {clientWebview && (
                                                <div
                                                    onClick={() =>
                                                        history.goBack()
                                                    }
                                                    className="absolute  flex justify-center items-center top-2 left-2 rounded-full h-10 w-10 bg-[#ffffffb3]"
                                                >
                                                    <BsArrowLeft className="text-black w-6 h-full" />
                                                </div>
                                            )}

                                            {!copiedText &&
                                                deal.redemptionType !==
                                                    'CONTACT' &&
                                                !showModal &&
                                                isExternalDeal && (
                                                    <div
                                                        className={`${
                                                            internalWebview
                                                                ? ' px-3 py-2 bg-white'
                                                                : ''
                                                        } fixed lg:static bottom-0 left-0 right-0 w-full lg:w-full z-30 lg:z-0`}
                                                        style={
                                                            internalWebview
                                                                ? {
                                                                      zIndex: 1000,
                                                                      position:
                                                                          'fixed',
                                                                      bottom: '0'
                                                                  }
                                                                : {}
                                                        }
                                                    >
                                                        <div
                                                            className={`${
                                                                internalWebview
                                                                    ? ' flex justify-center'
                                                                    : ''
                                                            } w-full lg:w-full `}
                                                        >
                                                            <RedeemAnimation
                                                                content={
                                                                    deal.ctaText
                                                                }
                                                                onClick={() => {
                                                                    if (
                                                                        !termsCheckbox
                                                                    ) {
                                                                        setShowTnCWarning(
                                                                            true
                                                                        ); // Show warning if TnC not checked
                                                                        return;
                                                                    }
                                                                    redeemNowClickedHandler(
                                                                        deal.url,
                                                                        deal.id,
                                                                        deal?.redemptionType
                                                                    );
                                                                }}
                                                                disabled={
                                                                    rememptionLoading
                                                                }
                                                                fullWidth
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    )}

                                    {(deal?.displayImage?.url &&
                                        deal?.videoUrl) ||
                                    deal?.additionalBannerImages?.length > 0 ? (
                                        <div
                                            id="DealsDetail"
                                            className="flex flex-row lg:hidden mt-2 overflow-x-scroll max-w-[100%]"
                                        >
                                            {deal?.videoUrl && (
                                                <div className="flex relative w-full justify-center">
                                                    <DealGalleryItem
                                                        imageUrl={
                                                            deal?.displayImage
                                                                ?.url
                                                        }
                                                        videoUrl={
                                                            deal?.videoUrl
                                                        }
                                                        previewItem={
                                                            previewItem
                                                        }
                                                        setPreviewItem={
                                                            setPreviewItem
                                                        }
                                                    />
                                                    <MdPlayCircleOutline className=" absolute self-center text-white text-4xl " />
                                                </div>
                                            )}
                                            {deal?.displayImage?.url && (
                                                <DealGalleryItem
                                                    imageUrl={
                                                        deal?.displayImage?.url
                                                    }
                                                    previewItem={previewItem}
                                                    setPreviewItem={
                                                        setPreviewItem
                                                    }
                                                />
                                            )}

                                            {deal?.additionalBannerImages
                                                ?.length > 0 &&
                                                deal?.additionalBannerImages?.map(
                                                    (d) => (
                                                        <DealGalleryItem
                                                            imageUrl={d?.url}
                                                            previewItem={
                                                                previewItem
                                                            }
                                                            setPreviewItem={
                                                                setPreviewItem
                                                            }
                                                        />
                                                    )
                                                )}
                                        </div>
                                    ) : null}

                                    <div className="w-[93%] mx-auto lg:w-[50%] lg:pl-7 h-full ">
                                        <div className="flex flex-col ">
                                            <div className="flex items-center justify-between mt-3 lg:mt-0">
                                                {!isExternalDeal && (
                                                    <p className="text-primary uppercase font-bold text-sm ">
                                                        {deal?.vendor?.name}
                                                    </p>
                                                )}
                                                {/* Share deal section */}
                                                {showShare &&
                                                    deal.shareable &&
                                                    !isRewards && (
                                                        <div className="flex ml-2">
                                                            <button
                                                                className=""
                                                                title="Click to share"
                                                                onClick={
                                                                    handleShareClick
                                                                }
                                                            >
                                                                <div className="flex flex-row items-center gap-1 sm:gap-2">
                                                                    <EnShareAlternative className="h-4 w-4 md:h-5 md:w-5" />
                                                                    <p className="z-10 text-sm font-semibold capitalize  font-sans cursor-pointer">
                                                                        Share
                                                                    </p>
                                                                </div>
                                                            </button>{' '}
                                                        </div>
                                                    )}
                                            </div>
                                            <div className=" flex flex-col justify-center ">
                                                <h1
                                                    className={`${
                                                        config?.darkMode
                                                            ? 'text-base-content'
                                                            : 'text-black '
                                                    } ${
                                                        isExternalDeal
                                                            ? 'mt-1'
                                                            : 'mt-1 lg:mt-3'
                                                    } medium text-2xl xl:text-3xl  font-semibold border-b-2 pb-3 `}
                                                >
                                                    {deal?.title}
                                                </h1>

                                                {!isRewards &&
                                                    deal?.couponId <= 0 && (
                                                        <DealValidity
                                                            date={deal?.endDate}
                                                            removeTopMargin={
                                                                deal?.couponId >
                                                                0
                                                            }
                                                        />
                                                    )}
                                                {/* PRICE DETAILS */}
                                                {isRewards && (
                                                    <div class="flex  items-center gap-4 mt-2">
                                                        <h3 className="text-sm font-medium text-gray-500 line-through">
                                                            MRP{' '}
                                                            <span className="">
                                                                {toIndianRs(
                                                                    deal?.productMrp
                                                                )}
                                                            </span>
                                                        </h3>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* TnC for Rewards */}
                                        {deal?.termsAndConditions &&
                                            isRewards && (
                                                <TnC
                                                    handleOnChange={
                                                        handleOnChange
                                                    }
                                                    termsCheckbox={
                                                        termsCheckbox
                                                    }
                                                    handleTnC={handleTnC}
                                                />
                                            )}

                                        {isRewards && (
                                            <button
                                                className={
                                                    ' mx-auto text-primary text-center text-sm font-semibold'
                                                }
                                                onClick={() =>
                                                    window.open(deal?.url)
                                                }
                                                title={`Compare with ${deal?.vendor?.name}`}
                                            >
                                                Compare the product
                                            </button>
                                        )}
                                        {isRewards && (
                                            <div
                                                className={`flex items-center gap-5 z-[99] lg:z-0 border-t-[1px]  lg:border-t-[0px]  border-color-[#dddd] left-0 right-0 bottom-0 w-full fixed lg:static px-[15px] lg:px-0 py-[10px] ${
                                                    itemAdded
                                                        ? 'px-3'
                                                        : 'bg-white'
                                                }`}
                                            >
                                                <button
                                                    onClick={() => {
                                                        if (!termsCheckbox) {
                                                            setShowTnCWarning(
                                                                true
                                                            ); // Show warning if TnC not checked
                                                            return; // Prevent further actions
                                                        }
                                                        handleCheckOut(true);
                                                    }}
                                                    className={`${
                                                        deal?.points >
                                                            totalRewardspoint ||
                                                        disableCart
                                                            ? 'opacity-50 cursor-not-allowed'
                                                            : ''
                                                    } rounded-md w-[50%] p-[15px]  px-[5px] lg:px-[15px]  lg:w-auto text-center bg-primary flex items-center justify-center   text-white font-normal  text-sm `}
                                                    disabled={
                                                        deal?.points >
                                                            totalRewardspoint ||
                                                        disableCart
                                                    }
                                                >
                                                    {BuyNowSvg} Buy Now
                                                </button>

                                                <>
                                                    {/*   Checkout and Refer Now Section */}
                                                    {deal?.points >
                                                        totalRewardspoint ||
                                                    disableCart ? (
                                                        <button
                                                            onClick={() =>
                                                                history.push(
                                                                    totalRewardspoint >
                                                                        0
                                                                        ? handleCheckOut(
                                                                              false
                                                                          )
                                                                        : '/gift-and-earn'
                                                                )
                                                            }
                                                            className={`flex  w-[50%]   p-[15px]  px-[5px] lg:px-[15px]  lg:w-auto items-center gap-2 border justify-center border-primary font-normal text-primary rounded-md transition   text-sm`}
                                                        >
                                                            <span>
                                                                {totalRewardspoint >
                                                                0
                                                                    ? 'Checkout'
                                                                    : 'Refer now'}
                                                            </span>
                                                        </button>
                                                    ) : (
                                                        <button
                                                            onClick={(
                                                                event
                                                            ) => {
                                                                event.stopPropagation(); // Prevent event bubbling
                                                                if (
                                                                    !termsCheckbox
                                                                ) {
                                                                    setShowTnCWarning(
                                                                        true
                                                                    ); // Show warning if TnC not checked
                                                                    return;
                                                                }
                                                                if (!itemAdded)
                                                                    OnCartClick(
                                                                        true
                                                                    ); // Call only if the button is not already clicked
                                                            }}
                                                            disabled={
                                                                deal?.points >
                                                                    totalRewardspoint ||
                                                                disableCart ||
                                                                itemAdded
                                                            }
                                                            className={`${
                                                                itemAdded
                                                                    ? 'bg-gray-200'
                                                                    : 'bg-gray-50'
                                                            } flex  w-[50%]  p-[15px]  px-[5px] lg:px-[15px] lg:w-auto items-center gap-2 border justify-center border-primary font-normal text-primary rounded-md transition   text-sm`}
                                                        >
                                                            {
                                                                <>
                                                                    <div
                                                                        id="main-tick"
                                                                        className={`${
                                                                            itemAdded
                                                                                ? 'w-[14px]'
                                                                                : 'w-[0px]'
                                                                        }`}
                                                                    >
                                                                        <div
                                                                            className={`${
                                                                                itemAdded
                                                                                    ? '   tick-animation active'
                                                                                    : ''
                                                                            } tick-animation overflow-hidden `}
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="14"
                                                                                height="10.2"
                                                                                viewBox="0 0 14 10.2"
                                                                            >
                                                                                <path
                                                                                    id="check"
                                                                                    d="M18.7,7.2a.967.967,0,0,0-1.4,0L9.8,14.7,6.7,11.6A.99.99,0,0,0,5.3,13l3.8,3.8a.967.967,0,0,0,1.4,0l8.2-8.2a.967.967,0,0,0,0-1.4Z"
                                                                                    transform="translate(-5 -6.9)"
                                                                                    fill="#4652a4"
                                                                                />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                    {!itemAdded && (
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="13.054"
                                                                            height="15.067"
                                                                            viewBox="0 0 13.054 15.067"
                                                                        >
                                                                            <g
                                                                                id="bag"
                                                                                transform="translate(-3.005 -0.995)"
                                                                            >
                                                                                <path
                                                                                    id="Path_7734"
                                                                                    data-name="Path 7734"
                                                                                    d="M16.056,13.1l-.91-8.743a1.5,1.5,0,0,0-1.5-1.351H11.991a2.511,2.511,0,0,0-4.921,0H5.413a1.5,1.5,0,0,0-1.5,1.35L3,13.1v.05a2.916,2.916,0,0,0,2.91,2.913h7.231a2.916,2.916,0,0,0,2.913-2.913A.446.446,0,0,0,16.056,13.1ZM9.531,2a1.509,1.509,0,0,1,1.421,1H8.11A1.509,1.509,0,0,1,9.531,2Zm3.616,13.056H5.915a1.908,1.908,0,0,1-1.908-1.884l.908-8.712a.5.5,0,0,1,.5-.452h8.235a.5.5,0,0,1,.5.452l.9,8.712a1.908,1.908,0,0,1-1.908,1.884Z"
                                                                                    fill="#4652a4"
                                                                                />
                                                                                <path
                                                                                    id="Path_7735"
                                                                                    data-name="Path 7735"
                                                                                    d="M15.519,11a.5.5,0,0,0-.5.5A1.506,1.506,0,1,1,12,11.5a.5.5,0,0,0-1,0,2.511,2.511,0,1,0,5.022,0A.5.5,0,0,0,15.519,11Z"
                                                                                    transform="translate(-3.98 -4.981)"
                                                                                    fill="#4652a4"
                                                                                />
                                                                            </g>
                                                                        </svg>
                                                                    )}
                                                                    {itemAdded ? (
                                                                        <span>
                                                                            Added
                                                                            to
                                                                            Gift
                                                                            Basket
                                                                        </span>
                                                                    ) : (
                                                                        <span>
                                                                            Add
                                                                            to
                                                                            Gift
                                                                            Basket
                                                                        </span>
                                                                    )}
                                                                </>
                                                            }
                                                        </button>
                                                    )}
                                                </>
                                            </div>
                                        )}

                                        {
                                            <Description
                                                content={deal?.description}
                                                title="Description"
                                                isRewards
                                                date={deal?.endDate}
                                                removeTopMargin={isExternalDeal}
                                            />
                                        }
                                        {!isRewards && isExternalDeal && (
                                            <DealValidity
                                                date={deal?.endDate}
                                                removeTopMargin={isExternalDeal}
                                            />
                                        )}
                                        {/* Redeem Button for Deals */}
                                        {!isRewards && !isExternalDeal && (
                                            <div
                                                className={`flex items-center lg:border-b-2 lg:border-gray-200 lg:border-0  lg:pb-0 w-full ${
                                                    internalWebview
                                                        ? ' mt-2 md:mt-3  pb-3'
                                                        : 'mt-4 lg:pb-6'
                                                }`}
                                            >
                                                {deal.redemptionType ===
                                                    'CONTACT' && (
                                                    <a
                                                        href={`tel:${deal?.vendor?.contactNumber}`}
                                                    >
                                                        <RedeemAnimation
                                                            content={
                                                                deal.ctaText
                                                            }
                                                            onClick={() => {
                                                                if (
                                                                    !termsCheckbox
                                                                ) {
                                                                    setShowTnCWarning(
                                                                        true
                                                                    ); // Show warning if TnC not checked
                                                                    return;
                                                                }
                                                                redeemNowClickedHandler(
                                                                    deal.url,
                                                                    deal.id,
                                                                    deal?.redemptionType
                                                                );
                                                            }}
                                                            disabled={
                                                                // !termsCheckbox ||
                                                                rememptionLoading
                                                            }
                                                        />
                                                    </a>
                                                )}
                                                <div className="flex flex-col lg:flex-row w-full">
                                                    <div></div>
                                                    {!copiedText &&
                                                        deal.redemptionType !==
                                                            'CONTACT' &&
                                                        !showModal && (
                                                            <div
                                                                className={`${
                                                                    internalWebview
                                                                        ? ' px-3 py-2 bg-white'
                                                                        : ''
                                                                } fixed lg:static bottom-0 left-0 right-0 w-full lg:w-auto z-30 lg:z-0`}
                                                                style={
                                                                    internalWebview
                                                                        ? {
                                                                              zIndex: 1000,
                                                                              position:
                                                                                  'fixed',
                                                                              bottom: '0'
                                                                          }
                                                                        : {}
                                                                }
                                                            >
                                                                <div
                                                                    className={`${
                                                                        internalWebview
                                                                            ? ' flex justify-center'
                                                                            : ''
                                                                    } w-full lg:w-auto `}
                                                                    //  style={internalWebview ? { zIndex: 1000 ,  position: 'fixed', bottom: '0'  } : {}}
                                                                >
                                                                    <RedeemAnimation
                                                                        content={
                                                                            deal.ctaText
                                                                        }
                                                                        onClick={() => {
                                                                            if (
                                                                                !termsCheckbox
                                                                            ) {
                                                                                setShowTnCWarning(
                                                                                    true
                                                                                ); // Show warning if TnC not checked
                                                                                return;
                                                                            }
                                                                            redeemNowClickedHandler(
                                                                                deal.url,
                                                                                deal.id,
                                                                                deal?.redemptionType
                                                                            );
                                                                        }}
                                                                        disabled={
                                                                            // !termsCheckbox ||
                                                                            rememptionLoading
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                    {/* Share deal modal */}
                                                    {showShareModal && (
                                                        <Modal
                                                            visible={
                                                                showShareModal
                                                            }
                                                            showButton
                                                            showCloseButton={
                                                                false
                                                            }
                                                            onClick={() =>
                                                                setShowShareModal(
                                                                    false
                                                                )
                                                            }
                                                        >
                                                            <div className="flex flex-col px-5 ">
                                                                {
                                                                    <>
                                                                        <div className="flex justify-between items-center my-4 ">
                                                                            <h1 className=" text-lg sm:text-xl font-bold ">
                                                                                Share
                                                                                this
                                                                                Deal
                                                                            </h1>
                                                                            <EiCloseO
                                                                                onClick={() =>
                                                                                    setShowShareModal(
                                                                                        false
                                                                                    )
                                                                                }
                                                                                className={` h-7 w-7 sm:h-9 sm:w-10 cursor-pointer   text-gray-500`}
                                                                            />
                                                                        </div>

                                                                        <svg viewBox="0 0 457 2">
                                                                            <defs></defs>
                                                                            <g
                                                                                id="Layer_2"
                                                                                data-name="Layer 2"
                                                                            >
                                                                                <g
                                                                                    id="Layer_1-2"
                                                                                    data-name="Layer 1"
                                                                                >
                                                                                    <polygon
                                                                                        class="cls-1"
                                                                                        points="0 1 57.13 0.51 114.25 0.23 228.5 0 342.75 0.23 399.88 0.51 457 1 399.88 1.49 342.75 1.77 228.5 2 114.25 1.76 57.13 1.49 0 1"
                                                                                        fill="#e5e5e5"
                                                                                    />
                                                                                </g>
                                                                            </g>
                                                                        </svg>

                                                                        <div className="flex gap-5 items-center my-5">
                                                                            <img
                                                                                variant="square"
                                                                                loading="lazy"
                                                                                className={`${
                                                                                    config
                                                                                        ?.projects
                                                                                        .moduleConfig
                                                                                        ?.QRCodeImage
                                                                                        ? 'h-10 w-10'
                                                                                        : 'h-20 w-28'
                                                                                } z-10  object-center object-cover rounded-lg`}
                                                                                src={
                                                                                    deal
                                                                                        .vendor
                                                                                        ?.logo
                                                                                        ?.url
                                                                                }
                                                                                alt="property"
                                                                            />
                                                                            <div className="flex flex-col ">
                                                                                <p className="text-black font-semibold text-base sm:text-lg">
                                                                                    {
                                                                                        deal?.title
                                                                                    }
                                                                                </p>
                                                                                <p className="text-[#908F95] text-sm sm:text-base italic">
                                                                                    {' '}
                                                                                    Valid
                                                                                    upto
                                                                                    :{' '}
                                                                                    {renderDate(
                                                                                        deal?.endDate
                                                                                    )}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <svg viewBox="0 0 457 2">
                                                                            <defs></defs>
                                                                            <g
                                                                                id="Layer_2"
                                                                                data-name="Layer 2"
                                                                            >
                                                                                <g
                                                                                    id="Layer_1-2"
                                                                                    data-name="Layer 1"
                                                                                >
                                                                                    <polygon
                                                                                        class="cls-1"
                                                                                        points="0 1 57.13 0.51 114.25 0.23 228.5 0 342.75 0.23 399.88 0.51 457 1 399.88 1.49 342.75 1.77 228.5 2 114.25 1.76 57.13 1.49 0 1"
                                                                                        fill="#e5e5e5"
                                                                                    />
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                        <div className="flex flex-wrap justify-between items-center mt-5 ">
                                                                            <div
                                                                                className={` w-[90%] lg:w-[45%]  md:w-[45%]  cursor-pointer  flex gap-2  border border-gray-400 rounded-[10px] p-3 my-2`}
                                                                            >
                                                                                <button
                                                                                    title={
                                                                                        copiedUrl
                                                                                            ? 'Link copied'
                                                                                            : 'Click to copy'
                                                                                    }
                                                                                    className=""
                                                                                    onClick={() =>
                                                                                        copyDealHandler()
                                                                                    }
                                                                                >
                                                                                    {!copiedUrl && (
                                                                                        <div className="flex items-center gap-3">
                                                                                            <FiCopy className="cursor-pointer w-5 h-full" />
                                                                                            <p className="font-bold text-sm sm:text-base">
                                                                                                Link
                                                                                                Copy
                                                                                            </p>
                                                                                        </div>
                                                                                    )}
                                                                                    {copiedUrl && (
                                                                                        <p className="mx-auto px-6 self-center  rounded-lg text-center font-normal animate-pulse bg-white text-xs sm:text-sm   text-[#006EB7] ">
                                                                                            Link
                                                                                            Copied
                                                                                        </p>
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                            <div
                                                                                className={` w-[90%] lg:w-[45%] md:w-[45%]  cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2`}
                                                                            >
                                                                                <EmailShareButton
                                                                                    url={
                                                                                        userRole ===
                                                                                        'CUSTOMER'
                                                                                            ? shareLink
                                                                                            : window
                                                                                                  .location
                                                                                                  .href
                                                                                    }
                                                                                    body={
                                                                                        deal.shareMessage
                                                                                            ? deal.shareMessage
                                                                                            : "Hello! Hope you're doing well. I wanted to share this exciting deal I found recently. Here's the link: 🏘️ Click to learn more!"
                                                                                    }
                                                                                    subject={
                                                                                        deal.shareMessage
                                                                                            ? deal.shareMessage
                                                                                            : "Hello! I wanted to share this exciting deal I found recently. Here's the link: 🏘️ Click to learn more!"
                                                                                    }
                                                                                >
                                                                                    <div className="flex items-center gap-3">
                                                                                        <MdcEmailOutline className="w-5 h-full" />
                                                                                        <p className="  font-bold text-sm sm:text-base">
                                                                                            Email
                                                                                        </p>
                                                                                    </div>
                                                                                </EmailShareButton>
                                                                            </div>
                                                                            <div
                                                                                className={` w-[90%] lg:w-[45%]  md:w-[45%] cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2`}
                                                                            >
                                                                                <WhatsappShareButton
                                                                                    url={
                                                                                        userRole ===
                                                                                        'CUSTOMER'
                                                                                            ? shareLink
                                                                                            : window
                                                                                                  .location
                                                                                                  .href
                                                                                    }
                                                                                    title={
                                                                                        deal.shareMessage
                                                                                            ? deal.shareMessage
                                                                                            : "Hello! Hope you're doing well. I wanted to share this exciting deal I found recently. Here's the link: 🏘️ Click to learn more!"
                                                                                    }
                                                                                >
                                                                                    <div className="flex items-center gap-3">
                                                                                        <SiWhatsapp className="w-5 h-full" />

                                                                                        <p className="  font-bold text-sm sm:text-base ">
                                                                                            WhatsApp
                                                                                        </p>
                                                                                    </div>
                                                                                </WhatsappShareButton>
                                                                            </div>
                                                                            <div
                                                                                className={` w-[90%] lg:w-[45%]  md:w-[45%] cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2`}
                                                                            >
                                                                                <FacebookShareButton
                                                                                    url={
                                                                                        userRole ===
                                                                                        'CUSTOMER'
                                                                                            ? shareLink
                                                                                            : window
                                                                                                  .location
                                                                                                  .href
                                                                                    }
                                                                                    title={
                                                                                        deal.shareMessage
                                                                                            ? deal.shareMessage
                                                                                            : "Hey friends! Just stumbled upon this incredible deal that I couldn't wait to share with you all. Take a look: 🌟 Click on the below link to explore further!"
                                                                                    }
                                                                                >
                                                                                    <div className="flex items-center gap-3">
                                                                                        <FaFacebookF className="w-5 h-full" />
                                                                                        <p className="font-bold text-sm sm:text-base ">
                                                                                            Facebook
                                                                                        </p>
                                                                                    </div>
                                                                                </FacebookShareButton>
                                                                            </div>
                                                                            <div
                                                                                className={` w-[90%] lg:w-[45%]  md:w-[45%]  cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2`}
                                                                            >
                                                                                <TwitterShareButton
                                                                                    url={
                                                                                        userRole ===
                                                                                        'CUSTOMER'
                                                                                            ? shareLink
                                                                                            : window
                                                                                                  .location
                                                                                                  .href
                                                                                    }
                                                                                    title={
                                                                                        deal.shareMessage
                                                                                            ? deal.shareMessage
                                                                                            : "Exciting news! Discovered a fantastic deal worth checking out. Here's the link: 🏢 Click to learn more!"
                                                                                    }
                                                                                >
                                                                                    <div className="flex items-center gap-3">
                                                                                        <svg
                                                                                            size={
                                                                                                20
                                                                                            }
                                                                                            className="w-5 text-black"
                                                                                            stroke="currentColor"
                                                                                            fill="currentColor"
                                                                                            stroke-width="0"
                                                                                            viewBox="0 0 24 24"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path d="M8 2H1L9.26086 13.0145L1.44995 21.9999H4.09998L10.4883 14.651L16 22H23L14.3917 10.5223L21.8001 2H19.1501L13.1643 8.88578L8 2ZM17 20L5 4H7L19 20H17Z"></path>
                                                                                        </svg>
                                                                                        <button className="  font-bold text-sm sm:text-base">
                                                                                            Twitter
                                                                                        </button>
                                                                                    </div>
                                                                                </TwitterShareButton>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                        </Modal>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {/* TnC for Deals */}
                                        {deal?.termsAndConditions &&
                                            !isRewards && (
                                                <TnC
                                                    handleOnChange={
                                                        handleOnChange
                                                    }
                                                    termsCheckbox={
                                                        termsCheckbox
                                                    }
                                                    handleTnC={handleTnC}
                                                />
                                            )}
                                    </div>
                                </div>
                            )}

                        {/* Description for Rewards */}
                        {isRewards && (
                            <div className="w-[93%] lg:w-full mx-auto">
                                <Description
                                    isRewards={isRewards}
                                    content={productSpecifications}
                                    title="Key Features"
                                />
                            </div>
                        )}

                        {isRewards && <RewardClaimDescription />}

                        <div className="w-[93%] lg:w-full mx-auto py-5">
                            <MoreOffers
                                similarOffers={similarOffers}
                                topOffers={topOffers}
                                sameBrandOffers={sameBrandOffers}
                                isRewards={isRewards}
                                isBundleDeal={isBundleDeal}
                            />
                        </div>
                    </div>
                )}
            </section>
            {/* TNC Modal */}
            <Modal
                className="w-[95%] lg:w-[80%]"
                visible={showTerms}
                onClick={() => setShowTerms(false)}
            >
                <div className="flex justify-end mr-4 mt-4 mb-2">
                    <GrClose
                        onClick={() => setShowTerms(false)}
                        className={` h-4 w-4 cursor-pointer self-end ml-auto`}
                    />
                </div>
                <div
                    className={` text-[#373737] text-sm lg:text-base font-medium break-words leading-[1.4] p-2 lg:p-10 overflow-y-scroll h-[90vh] lg:h-auto `}
                >
                    <p>
                        By clicking on {isRewards ? 'Buy at' : deal.ctaText} ,
                        you agree & authorize Reloy and{' '}
                        {isBundleDeal
                            ? 'all partner brands part of this bundle deal'
                            : 'partner brands'}{' '}
                        to call you or contact you via various communication
                        modes to assist you with your queries. This consent will
                        override your DNC/NDNC registration if any.
                    </p>
                    <div
                        className="mt-5"
                        dangerouslySetInnerHTML={
                            isHTML(deal.termsAndConditions)
                                ? {
                                      __html: deal.termsAndConditions
                                  }
                                : {
                                      __html: `<p>${deal.termsAndConditions}</p>`
                                  }
                        }
                    ></div>
                </div>
            </Modal>
            {/* TNC Warning Modal */}
            {showTnCWarning && (
                <Modal
                    className="w-[95%] md:w-[45%] lg:w-[40%] xl:w-[30%]"
                    visible={showTnCWarning}
                    onClick={() => setShowTnCWarning(false)}
                >
                    <div className="flex justify-end mr-4 mt-4">
                        <GrClose
                            onClick={() => setShowTnCWarning(false)}
                            className={` h-4 w-4 cursor-pointer self-end ml-auto`}
                        />
                    </div>
                    <div className="text-center px-4 py-2">
                        <p className="text-[#373737] text-sm lg:text-base font-medium">
                            Please accept the Terms and Conditions to continue.
                            This step is required to{' '}
                            {isRewards
                                ? 'redeem your reward'
                                : 'access the deal'}
                            .
                        </p>
                        <button
                            className="mt-4 bg-primary text-white py-2 px-4 rounded mb-2"
                            onClick={() => setShowTnCWarning(false)}
                        >
                            Got it
                        </button>
                    </div>
                </Modal>
            )}
            {/* Modal to show messages for unregistered user from redeeming deal*/}
            {showUnregisteredModal && (
                <Modal
                    className="w-[95%] md:w-[55%] lg:w-[50%] xl:w-[45%]"
                    visible={showUnregisteredModal}
                    onClick={() => setShowUnregisteredModal(false)}
                >
                    <div className="flex justify-end mr-4 mt-4">
                        <GrClose
                            onClick={() => setShowUnregisteredModal(false)}
                            className={` h-4 w-4 cursor-pointer self-end ml-auto`}
                        />
                    </div>
                    <div className="text-left px-4 pb-8">
                        <h1 className="font-bold text-xl">Hello There</h1>
                        <p className="text-sm lg:text-base font-medium mt-2">
                            Your registration is being reviewed.
                        </p>
                        <p className="text-sm lg:text-base font-medium mt-1">
                            Once it is approved, you will become eligible for
                            our benefits!
                        </p>
                    </div>
                </Modal>
            )}

            {/*  Modal for Multiple redemption deal */}
            {showMultipleRedemption && (
                <Modal
                className="w-[100%] md:w-[95%] lg:w-[50%] xl:w-[35%]"
                visible={showMultipleRedemption}
                onClick={() => setShowMultipleRedemption(false)}
              >
                <div className="flex justify-end mr-4 mt-4">
                  <GrClose
                    onClick={() => setShowMultipleRedemption(false)}
                    className="h-4 w-4 cursor-pointer self-end ml-auto"
                  />
                </div>
                <div className="text-center px-4 pb-8">
                  <div className="flex flex-col items-center mb-2">
                    <img
                      className="h-[84px] w-[84px] -mb-3"
                      src="https://htmlemailer.s3.ap-south-1.amazonaws.com/html-media/godrej/Gift-box-new.gif"
                      alt="Gift box animation"
                    />
                    <p className="font-bold text-black text-lg">Congratulations!</p>
                  </div>
                  <p className='text-sm lg:text-base font-medium mt-1'>Thank you for redeeming this offer!</p>
                  <p className="mt-1 text-sm lg:text-base">
                    Your coupon code has been sent to your email and WhatsApp. Please present it at the venue to redeem your offer.
                  </p>
                </div>
              </Modal>
              
            )}

            {/* DEAL CODES MODAL */}
            <Modal
                visible={showModal}
                // visible={true}
                onClick={() => setShowModal(false)}
                className={'w-[100%] md:w-[95%] lg:w-[50%] xl:w-[30%]'}
            >
                <div className="flex justify-between px-4 mt-4 -mb-2 ">
                    {isVoucherDeal || isCodeDeal ? (
                        <div className=" font-semibold">
                            {isVoucherDeal ? 'VOUCHER DETAILS' : 'DEAL DETAILS'}
                        </div>
                    ) : null}
                    <GrClose
                        onClick={() => setShowModal(false)}
                        className={` h-4 w-4 cursor-pointer self-end ml-auto`}
                    />
                </div>
                {captureUserMobile && (
                    <PhoneNumber
                        redeemNowClickedHandler={(mobile) =>
                            redeemNowClickedHandler({
                                url: deal.url,
                                id: deal.id,
                                redemptionType: deal?.redemptionType,
                                mobile
                            })
                        }
                        setCaptureUserMobile={setCaptureUserMobile}
                    />
                )}
                {!captureUserMobile && (
                    <div className="relative pt-4 pb-6 flex flex-col">
                        <p
                            className={`
                        ${
                            config?.deals.dealsSection.subAdditionalTextClass
                                ? config?.deals.dealsSection
                                      .subAdditionalTextClass
                                : ''
                        } z-10 mt-2 px-4 text-center font-semibold `}
                        >
                            {isBundleDeal ? (
                                <p>
                                    Thank you for redeeming the exciting offers
                                    part of this Housewarming Kit. You will be
                                    communicated the steps to redeem shortly.{' '}
                                </p>
                            ) : isVoucherDeal || isCodeDeal ? (
                                voucherCode && !modalMessage ? (
                                    <>
                                        <div
                                            className={`flex flex-col justify-center items-center ${
                                                deal?.redemptionType ===
                                                'VOUCHER'
                                                    ? 'border-b-[2px] border-gray-200 pb-3'
                                                    : ''
                                            }`}
                                        >
                                            <img
                                                className=" h-[84px] w-[84px] -mb-3"
                                                src="https://htmlemailer.s3.ap-south-1.amazonaws.com/html-media/godrej/Gift-box-new.gif"
                                            />
                                            <p className="font-semibold text-lg">
                                                Congratulations!
                                            </p>
                                            <p>
                                                {deal?.redemptionType ===
                                                'VOUCHER'
                                                    ? 'Your voucher is redeemed 🎉'
                                                    : 'Here are your coupon details'}
                                            </p>
                                        </div>

                                        <div className="mt-4 ">
                                            {deal?.redemptionType ===
                                                'VOUCHER' && (
                                                <div className="flex">
                                                    <img
                                                        className="h-16 w-16"
                                                        src={
                                                            deal?.displayImage
                                                                ?.url
                                                        }
                                                    />

                                                    <h1 className="text-left ml-2 font-semibold">
                                                        {deal?.title}
                                                    </h1>
                                                </div>
                                            )}
                                            {isVoucherDeal &&
                                                isOnlineDeal &&
                                                voucherCode && (
                                                    <div className="flex justify-between items-center">
                                                        <div className="flex my-2 justify-center items-center">
                                                            {!copiedText && (
                                                                <div
                                                                    onClick={() =>
                                                                        handleCopyCode()
                                                                    }
                                                                    title="Click to copy "
                                                                    className=" py-1 flex justify-center items-center  gap-[2px] cursor-pointer rounded border-2  border-[#5ea4c7] border-dashed px-4 mb-2 lg:mb-0 bg-[#eaf1f6b3]"
                                                                >
                                                                    <p
                                                                        className={`${
                                                                            config
                                                                                ?.deals
                                                                                .dealLayout
                                                                                .couponClassName
                                                                                ? config
                                                                                      ?.deals
                                                                                      .dealLayout
                                                                                      .couponClassName
                                                                                : ''
                                                                        } z-10 font-semibold text-center ${
                                                                            config?.darktheme
                                                                                ? 'hover:border-[#68BBE3]'
                                                                                : 'hover:border-blue-900'
                                                                        }`}
                                                                    >
                                                                        {
                                                                            voucherCode
                                                                        }
                                                                    </p>
                                                                    {/* {copySvg} */}
                                                                </div>
                                                            )}

                                                            {copiedText && (
                                                                <p
                                                                    className={`z-10 self-center font-normal animate-pulse ${
                                                                        config?.darktheme
                                                                            ? 'bg-[#68BBE3B3]  text-white'
                                                                            : 'bg-[#154F9D1A] text-[#006EB7]'
                                                                    }   py-2 px-12 text-sm rounded `}
                                                                >
                                                                    Code Copied
                                                                </p>
                                                            )}
                                                        </div>

                                                        <button
                                                            onClick={() =>
                                                                handleCopyCode()
                                                            }
                                                            className="text-sm text-[#006EB7]"
                                                        >
                                                            TAP TO COPY
                                                        </button>
                                                    </div>
                                                )}
                                            {isCodeDeal && voucherCode && (
                                                <div className="flex flex-col justify-between items-center">
                                                    <div className="flex my-2 justify-center items-center">
                                                        {!copiedText && (
                                                            <div
                                                                onClick={() =>
                                                                    handleCopyCode()
                                                                }
                                                                title="Click to copy "
                                                                className=" py-1 flex justify-center items-center gap-[2px] cursor-pointer rounded border-2  border-[#5ea4c7] border-dashed px-10 mb-2 lg:mb-0 bg-[#eaf1f6b3]"
                                                            >
                                                                <p
                                                                    className={` z-10 font-semibold text-center ${
                                                                        config?.darktheme
                                                                            ? 'hover:border-[#68BBE3]'
                                                                            : 'hover:border-blue-900'
                                                                    }`}
                                                                >
                                                                    {
                                                                        voucherCode
                                                                    }
                                                                </p>
                                                                {/* {copySvg} */}
                                                            </div>
                                                        )}

                                                        {copiedText && (
                                                            <p
                                                                className={`z-10 self-center font-normal animate-pulse ${
                                                                    config?.darktheme
                                                                        ? 'bg-[#68BBE3B3]  text-white'
                                                                        : 'bg-[#154F9D1A] text-[#006EB7]'
                                                                }   py-2 px-12 text-sm rounded `}
                                                            >
                                                                Code Copied
                                                            </p>
                                                        )}
                                                    </div>

                                                    <button
                                                        onClick={() =>
                                                            handleCopyCode()
                                                        }
                                                        className="text-sm text-[#006EB7]"
                                                    >
                                                        TAP TO COPY
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="mt-4 border-b-[2px] border-gray-200 pb-3 ">
                                            <div className="flex">
                                                <img
                                                    className="h-16 w-16"
                                                    src={
                                                        deal?.displayImage?.url
                                                    }
                                                />
                                                <h1 className="text-left ml-2 font-semibold">
                                                    {deal?.title}
                                                </h1>
                                            </div>
                                            {(deal?.redemptionType ===
                                                'VOUCHER' ||
                                                deal?.redemptionType ==
                                                    'CODE') &&
                                                voucherCode &&
                                                isOnlineDeal && (
                                                    <div className="flex justify-between items-center">
                                                        <div className="flex my-2 justify-center items-center">
                                                            {!copiedText && (
                                                                <div
                                                                    onClick={() =>
                                                                        handleCopyCode()
                                                                    }
                                                                    title="Click to copy "
                                                                    className=" py-1 flex justify-center items-center  gap-[2px] cursor-pointer rounded border-2  border-[#5ea4c7] border-dashed px-4 mb-2 lg:mb-0 bg-[#eaf1f6b3]"
                                                                >
                                                                    <p
                                                                        className={`${
                                                                            config
                                                                                ?.deals
                                                                                .dealLayout
                                                                                .couponClassName
                                                                                ? config
                                                                                      ?.deals
                                                                                      .dealLayout
                                                                                      .couponClassName
                                                                                : ''
                                                                        } z-10 font-semibold text-center ${
                                                                            config?.darktheme
                                                                                ? 'hover:border-[#68BBE3]'
                                                                                : 'hover:border-blue-900'
                                                                        }`}
                                                                    >
                                                                        {
                                                                            voucherCode
                                                                        }
                                                                    </p>
                                                                    {/* {copySvg} */}
                                                                </div>
                                                            )}

                                                            {copiedText && (
                                                                <p
                                                                    className={`z-10 self-center font-normal animate-pulse ${
                                                                        config?.darktheme
                                                                            ? 'bg-[#68BBE3B3]  text-white'
                                                                            : 'bg-[#154F9D1A] text-[#006EB7]'
                                                                    }   py-2 px-12 text-sm rounded `}
                                                                >
                                                                    Code Copied
                                                                </p>
                                                            )}
                                                        </div>
                                                        <button
                                                            onClick={() =>
                                                                handleCopyCode()
                                                            }
                                                            className="text-sm text-[#006EB7]"
                                                        >
                                                            TAP TO COPY
                                                        </button>
                                                    </div>
                                                )}
                                        </div>
                                        <div className="flex items-center mt-4">
                                            <div className="animate-pulse w-12 h-auto">
                                                {AlertSvg}
                                            </div>
                                            <p className="ml-2 text-left text-sm">
                                                {modalMessage}
                                            </p>
                                        </div>
                                        {isOfflineDeal && (
                                            <div className="flex flex-col justify-center items-center mt-4">
                                                <img
                                                    src={voucherCode}
                                                    className="h-36 w-36"
                                                />
                                                <p className="text-sm">
                                                    Show this code at the store
                                                </p>
                                            </div>
                                        )}
                                    </>
                                )
                            ) : modalMessage ? (
                                modalMessage
                            ) : (
                                <div className=" flex items-start justify-center text-left text-sm md:px-3 py-1 px-2 overflow-y-scroll pb-4 max-h-[80vh] scrollbar-thin">
                                    {redemptionId && (
                                        <DealEnquiry
                                            dealRedemptionId={redemptionId}
                                            prefilledData={prefilledData}
                                        />
                                    )}
                                </div>
                            )}
                        </p>

                        {((isVoucherDeal && isOnlineDeal) || isCodeDeal) &&
                        deal?.url ? (
                            voucherCode &&
                            !isOfflineTag && (
                                <div className="flex flex-col justify-center items-center mt-6">
                                    <RedeemAnimation
                                        content={`
                                        Visit ${deal?.vendor?.name} to claim
                                     `}
                                        onClick={() => {
                                            window.open(deal?.url);
                                        }}
                                        title={`If the button does not work, copy the link and open it manually`}
                                    />
                                    {!copiedLink ? (
                                        <button
                                            onClick={handleCopyLink}
                                            className="text-[#3386bd] rounded-md transition-all mt-2 text-sm md:text-base"
                                            title="Copy link to clipboard"
                                        >
                                            COPY LINK
                                        </button>
                                    ) : (
                                        <p
                                            className={`z-10 self-center font-normal animate-pulse mt-2 ${
                                                config?.darktheme
                                                    ? 'bg-[#68BBE3B3] text-white'
                                                    : 'bg-[#154F9D1A] text-[#006EB7]'
                                            } py-2 px-12 text-sm rounded`}
                                        >
                                            Link Copied
                                        </p>
                                    )}
                                </div>
                            )
                        ) : isBundleDeal ? (
                            <></>
                        ) : (
                            <></>
                        )}
                    </div>
                )}
            </Modal>

            {showSurvey && !isRewards && (
                <MiniSurvey
                    handleCloseSurvey={handleCloseSurvey}
                    showSurvey={showSurvey}
                />
            )}
            {isRewards && showRewardsModal && <RewardsPopupModal />}
            {isRewards && openKYCModal && (
                <KYCModal
                    visible={openKYCModal}
                    onClick={closeKYCModal}
                    userAccountSummary={userAccountSummary}
                    getUserAccountSummary={getUserAccountSummary}
                    setOpenKYCModal={setOpenKYCModal}
                    closeKYCModal={closeKYCModal}
                    step={step}
                    setStep={setStep}
                    checkKycVerificationStatus={checkKycVerificationStatus}
                    loading={loading}
                    checkBankVerificationStatus={checkBankVerificationStatus}
                    isUpdateWorkflow={isUpdateWorkflow}
                    isKycCompleted={isKycCompleted}
                    initiateWorkflow={initiateWorkflow}
                    claimInProgress={claimInProgress}
                    rewardTypeSelected={rewardTypeSelected}
                    setClaimInProgress={setClaimInProgress}
                    cashOutFlow={cashOutFlow}
                    bankstatus={bankstatus}
                    isKycFailed={isKycFailed}
                    isBankVerificationFailed={isBankVerificationFailed}
                    isKycProcessing={isKycProcessing}
                />
            )}

            <Modal
                visible={itemAdded}
                onClick={() => setItemAdded(false)}
                className={`w-[85%] lg:w-[25%] xl:w-[18%] rounded-xl lg:block hidden`}
            >
                <div className=" bg-white  flex flex-col items-center justify-center rounded-3xl py-2">
                    <div className="absolute -top-10 z-10 ">{TickSvg}</div>
                    <div className=" flex flex-col justify-center items-center  font-semibold pt-11 pb-5 gap-2">
                        <h2 className="text-2xl mt-2 text-bold">Amazing!</h2>
                        <p className="text-center">
                            {' '}
                            Fill your cart and gift yourself the happiness!
                        </p>
                        <button
                            class="px-4 py-2  text-white bg-primary rounded-lg mt-2 font-semibold "
                            onClick={() => history.push('/rewardStore')}
                        >
                            Grab More Rewards
                        </button>
                    </div>
                </div>
            </Modal>
            <Fireworks itemAdded={itemAdded} />
            <SideModal
                visible={itemAdded}
                onClick={() => setItemAdded(false)}
                className={`w-full top-[68%] rounded-t-2xl lg:hidden mx-auto px-3 z-[99999]`}
            >
                <div className=" bg-white  flex flex-col items-center justify-center rounded-3xl py-2">
                    <div className="absolute -top-10 z-10 ">{TickSvg}</div>
                    <div className=" flex flex-col justify-center items-center  font-semibold pt-11 gap-2">
                        <h2 className="text-2xl mt-2 text-bold">Amazing!</h2>
                        <p className="text-center mt-2">
                            {' '}
                            Fill your cart and gift yourself the happiness!
                        </p>
                        <button
                            class="px-4 py-2  text-white bg-primary rounded-lg mt-2 font-semibold "
                            onClick={() => history.push('/rewardStore')}
                        >
                            Grab More Rewards
                        </button>
                    </div>
                </div>
            </SideModal>
        </div>
    );
}

export default DealDetails;
